import { useState, useEffect } from 'react'

const API = `${import.meta.env.VITE_API_URL || 'http://localhost:3001'}`

function AdminAnuncios() {
    const [anuncios, setAnuncios] = useState([])
    const [loading, setLoading] = useState(true)
    const [erro, setErro] = useState('')
    const [busca, setBusca] = useState('')
    const [filtro, setFiltro] = useState('todos')
    const [pagina, setPagina] = useState(1)
    const [totalPaginas, setTotalPaginas] = useState(1)

    // Estados do Modal de Detalhes do Anúncio
    const [adSelecionado, setAdSelecionado] = useState(null)
    const [adDetalhes, setAdDetalhes] = useState(null)
    const [midias, setMidias] = useState([])
    const [detalhesCarregando, setDetalhesCarregando] = useState(false)
    const [erroDetalhes, setErroDetalhes] = useState('')

    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }

    useEffect(() => {
        carregarAnuncios()
    }, [pagina, filtro])

    const abrirDetalhes = async (ad) => {
        setAdSelecionado(ad)
        setAdDetalhes(null)
        setMidias([])
        setErroDetalhes('')
        setDetalhesCarregando(true)

        try {
            const res = await fetch(`${API}/api/admin/anuncios/${ad.id}`, { headers })
            if (!res.ok) throw new Error('Erro ao carregar detalhes profundos do anúncio')
            const data = await res.json()
            setAdDetalhes(data.anuncio)
            setMidias(data.midias || [])
        } catch (error) {
            console.error('Erro ao buscar detalhes do anúncio:', error)
            setErroDetalhes('Não foi possível carregar as informações completas deste anúncio no banco de dados.')
        } finally {
            setDetalhesCarregando(false)
        }
    }

    const carregarAnuncios = async () => {
        setLoading(true)
        setErro('')
        try {
            const params = new URLSearchParams({ page: pagina, limit: 15 })
            if (filtro !== 'todos') params.append('status', filtro)
            if (busca) params.append('search', busca)

            const res = await fetch(`${API}/api/admin/anuncios?${params}`, { headers })
            if (!res.ok) throw new Error('Erro ao carregar anúncios')

            const data = await res.json()
            setAnuncios(data.anuncios || [])
            setTotalPaginas(data.totalPaginas || 1)
        } catch (error) {
            console.error('Erro:', error)
            setErro('Não foi possível carregar os anúncios.')
        } finally {
            setLoading(false)
        }
    }

    const handleBusca = (e) => {
        e.preventDefault()
        setPagina(1)
        carregarAnuncios()
    }

    const handleLiberarEdicao = async (id) => {
        if (!confirm('Liberar edição para este anúncio?')) return
        try {
            const res = await fetch(`${API}/api/admin/anuncios/${id}/liberar-edicao`, {
                method: 'PUT',
                headers
            })
            if (!res.ok) throw new Error('Erro ao liberar edição')
            alert('Edição liberada com sucesso!')
            carregarAnuncios()
        } catch (error) {
            alert('Erro: ' + error.message)
        }
    }

    const handleToggleDestaque = async (id) => {
        const ad = anuncios.find(a => a.id === id)
        const novoDestaque = !ad?.destaque
        try {
            const res = await fetch(`${API}/api/admin/anuncios/${id}/destaque`, {
                method: 'PUT',
                headers,
                body: JSON.stringify({ destaque: novoDestaque })
            })
            if (!res.ok) throw new Error('Erro ao alterar destaque')
            carregarAnuncios()
        } catch (error) {
            alert('Erro: ' + error.message)
        }
    }

    const handleRemover = async (id) => {
        if (!confirm('Tem certeza que deseja remover este anúncio? Esta ação é irreversível.')) return
        try {
            const res = await fetch(`${API}/api/admin/anuncios/${id}`, {
                method: 'DELETE',
                headers
            })
            if (!res.ok) throw new Error('Erro ao remover anúncio')
            carregarAnuncios()
        } catch (error) {
            alert('Erro: ' + error.message)
        }
    }

    const formatPrice = (value) => {
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 0 }).format(value || 0)
    }

    const formatDate = (date) => date ? new Date(date).toLocaleDateString('pt-BR') : '—'

    const getStatusBadge = (anuncio) => {
        if (anuncio.status === 'vendido') return <span className="admin-badge admin-badge-vendido">Vendido</span>
        if (!anuncio.ativo) return <span className="admin-badge admin-badge-inativo">Inativo</span>
        if (anuncio.data_expiracao && new Date(anuncio.data_expiracao) <= new Date()) return <span className="admin-badge admin-badge-expirado">Expirado</span>
        return <span className="admin-badge admin-badge-ativo">Ativo</span>
    }

    const filtros = [
        { key: 'todos', label: 'Todos' },
        { key: 'ativo', label: 'Ativos' },
        { key: 'expirado', label: 'Expirados' },
        { key: 'vendido', label: 'Vendidos' },
        { key: 'inativo', label: 'Inativos' },
    ]

    return (
        <div>
            <div className="admin-section-header" style={{ marginBottom: '1.5rem' }}>
                <h3>📢 Gestão de Anúncios</h3>
            </div>

            {erro && <div className="admin-error">{erro}</div>}

            {/* Toolbar */}
            <div className="admin-toolbar">
                <form onSubmit={handleBusca} style={{ flex: 1, display: 'flex', minWidth: 220 }}>
                    <input
                        type="text"
                        className="admin-search-input"
                        placeholder="Buscar por título..."
                        value={busca}
                        onChange={(e) => setBusca(e.target.value)}
                        style={{ flex: 1 }}
                    />
                </form>
                <div className="admin-filter-tabs">
                    {filtros.map(f => (
                        <button
                            key={f.key}
                            className={`admin-filter-tab ${filtro === f.key ? 'active' : ''}`}
                            onClick={() => { setFiltro(f.key); setPagina(1) }}
                        >
                            {f.label}
                        </button>
                    ))}
                </div>
            </div>

            {/* Table */}
            {loading ? (
                <div className="admin-loading">
                    <div className="spinner"></div>
                    <span>Carregando anúncios...</span>
                </div>
            ) : (
                <div className="admin-section">
                    <div className="admin-table-wrapper">
                        <table className="admin-table">
                            <thead>
                                <tr>
                                    <th>Foto</th>
                                    <th>Título</th>
                                    <th className="hide-mobile">Vendedor</th>
                                    <th>Preço</th>
                                    <th>Categoria</th>
                                    <th>Status</th>
                                    <th className="hide-mobile">Expiração</th>
                                    <th>Views</th>
                                    <th className="hide-tablet hide-mobile">Criado em</th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {anuncios.length > 0 ? (
                                    anuncios.map(ad => (
                                        <tr 
                                            key={ad.id}
                                            onClick={() => abrirDetalhes(ad)}
                                            style={{ cursor: 'pointer', transition: 'all 0.15s ease' }}
                                            className="admin-ad-row"
                                            title="Clique para ver os detalhes profundos deste anúncio"
                                        >
                                            <td data-label="Foto">
                                                {(ad.imagens?.[0] || ad.imagem) ? (
                                                    <img
                                                        src={ad.imagens?.[0] || ad.imagem}
                                                        alt=""
                                                        className="ad-thumb"
                                                    />
                                                ) : (
                                                    <div style={{
                                                        width: 50, height: 38, borderRadius: 6,
                                                        background: 'var(--color-bg-card)',
                                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                        fontSize: '1rem', color: 'var(--color-text-muted)'
                                                    }}>
                                                        🐂
                                                    </div>
                                                )}
                                            </td>
                                            <td data-label="Título" style={{ color: '#f8fafc', fontWeight: 500, maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                {ad.titulo}
                                                {ad.destaque && <span style={{ marginLeft: 6, fontSize: '0.75rem' }}>⭐</span>}
                                            </td>
                                            <td data-label="Vendedor" className="hide-mobile">{ad.vendedor_nome || ad.vendedorNome || '—'}</td>
                                            <td data-label="Preço" style={{ fontWeight: 600, color: 'var(--color-primary-light)' }}>
                                                {formatPrice(ad.preco)}
                                            </td>
                                            <td data-label="Categoria">{ad.categoria || '—'}</td>
                                            <td data-label="Status">{getStatusBadge(ad)}</td>
                                            <td data-label="Expiração" className="hide-mobile">{formatDate(ad.data_expiracao)}</td>
                                            <td data-label="Views" style={{ textAlign: 'center' }}>{ad.visualizacoes || 0}</td>
                                            <td data-label="Criado em" className="hide-tablet hide-mobile">{formatDate(ad.criado_em || ad.criadoEm)}</td>
                                            <td data-label="Ações">
                                                <div className="admin-actions-cell" onClick={(e) => e.stopPropagation()}>
                                                    <button
                                                        className="admin-action-btn info"
                                                        onClick={(e) => { e.stopPropagation(); handleLiberarEdicao(ad.id); }}
                                                        title="Liberar Edição"
                                                    >
                                                        🔓
                                                    </button>
                                                    <button
                                                        className="admin-action-btn warning"
                                                        onClick={(e) => { e.stopPropagation(); handleToggleDestaque(ad.id); }}
                                                        title="Destaque"
                                                    >
                                                        ⭐
                                                    </button>
                                                    <button
                                                        className="admin-action-btn danger"
                                                        onClick={(e) => { e.stopPropagation(); handleRemover(ad.id); }}
                                                        title="Remover"
                                                    >
                                                        🗑️
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="10" style={{ textAlign: 'center', padding: '2rem', color: '#64748b' }}>
                                            Nenhum anúncio encontrado.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    <div className="admin-pagination">
                        <button disabled={pagina <= 1} onClick={() => setPagina(p => p - 1)}>
                            ← Anterior
                        </button>
                        <span className="page-info">Página {pagina} de {totalPaginas}</span>
                        <button disabled={pagina >= totalPaginas} onClick={() => setPagina(p => p + 1)}>
                            Próxima →
                        </button>
                    </div>
                </div>
            )}

            {/* Modal Premium de Detalhes do Anúncio */}
            {adSelecionado && (
                <div 
                    className="admin-modal-overlay" 
                    style={{ display: 'flex' }} 
                    onClick={() => setAdSelecionado(null)}
                >
                    <div 
                        className="admin-modal" 
                        style={{ 
                            maxWidth: '750px', 
                            background: 'rgba(15, 23, 42, 0.96)',
                            backdropFilter: 'blur(16px)',
                            border: '1px solid rgba(255, 255, 255, 0.08)',
                            borderRadius: '16px',
                            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.75)',
                            padding: '1.75rem',
                            animation: 'adminModalFadeIn 0.2s cubic-bezier(0.16, 1, 0.3, 1)',
                            color: '#cbd5e1'
                        }} 
                        onClick={(e) => e.stopPropagation()}
                    >
                        
                        {/* Header */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem', borderBottom: '1px solid rgba(255, 255, 255, 0.08)', paddingBottom: '0.75rem' }}>
                            <div>
                                <h3 style={{ margin: 0, fontSize: '1.2rem', fontWeight: 700, color: '#f8fafc', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    📢 Detalhes do Anúncio
                                </h3>
                                <span style={{ fontSize: '0.75rem', color: '#64748b', fontFamily: 'monospace' }}>
                                    ID do Anúncio: {adSelecionado.id}
                                </span>
                            </div>
                            <button 
                                onClick={() => setAdSelecionado(null)}
                                style={{
                                    background: 'rgba(255, 255, 255, 0.05)',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '32px',
                                    height: '32px',
                                    cursor: 'pointer',
                                    color: '#94a3b8',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '1.2rem',
                                    transition: 'all 0.2s'
                                }}
                                onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(239, 68, 68, 0.15)'; e.currentTarget.style.color = '#ef4444' }}
                                onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)'; e.currentTarget.style.color = '#94a3b8' }}
                            >
                                &times;
                            </button>
                        </div>

                        {/* Modal Body */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem', maxHeight: '68vh', overflowY: 'auto', paddingRight: '4px' }}>
                            
                            {detalhesCarregando ? (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#94a3b8', fontSize: '0.9rem', padding: '3rem', justifyContent: 'center' }}>
                                    <div className="spinner" style={{ width: '24px', height: '24px', border: '3px solid rgba(255,255,255,0.1)', borderTopColor: 'var(--color-primary-light)', borderRadius: '50%', animation: 'spin 0.7s linear infinite' }}></div>
                                    <span>Carregando dados detalhados do anúncio...</span>
                                </div>
                            ) : erroDetalhes ? (
                                <div style={{ color: '#f87171', fontSize: '0.9rem', background: 'rgba(239, 68, 68, 0.05)', padding: '1rem', borderRadius: '8px', border: '1px solid rgba(239, 68, 68, 0.1)', textAlign: 'center' }}>
                                    {erroDetalhes}
                                </div>
                            ) : adDetalhes ? (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
                                    
                                    {/* Mídias / Galeria */}
                                    <div style={{ background: 'rgba(15, 23, 42, 0.4)', borderRadius: '12px', padding: '0.75rem', border: '1px solid rgba(255, 255, 255, 0.05)' }}>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center' }}>
                                            {midias.length > 0 ? (
                                                midias.map((m, idx) => (
                                                    <div key={m.id || idx} style={{ position: 'relative', borderRadius: '8px', overflow: 'hidden', border: '1px solid rgba(255,255,255,0.1)', width: '120px', height: '90px' }}>
                                                        <img 
                                                            src={m.url_comprimida || m.url_original} 
                                                            alt="" 
                                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                        />
                                                    </div>
                                                ))
                                            ) : (adDetalhes.imagens?.[0] || adDetalhes.imagem) ? (
                                                <div style={{ borderRadius: '8px', overflow: 'hidden', border: '1px solid rgba(255,255,255,0.1)', width: '100%', maxHeight: '200px', display: 'flex', justifyContent: 'center' }}>
                                                    <img 
                                                        src={adDetalhes.imagens?.[0] || adDetalhes.imagem} 
                                                        alt="" 
                                                        style={{ maxHeight: '200px', objectFit: 'contain' }}
                                                    />
                                                </div>
                                            ) : (
                                                <div style={{ padding: '2rem', color: '#64748b', fontSize: '0.85rem' }}>
                                                    Sem mídias cadastradas para este anúncio.
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Informações Básicas */}
                                    <div className="admin-grid-2" style={{ gap: '1rem' }}>
                                        <div style={{ background: 'rgba(255, 255, 255, 0.02)', padding: '0.75rem 1rem', borderRadius: '8px', border: '1px solid rgba(255, 255, 255, 0.04)' }}>
                                            <span style={{ fontSize: '0.7rem', color: '#64748b', textTransform: 'uppercase', fontWeight: 700, letterSpacing: '0.5px', display: 'block', marginBottom: '4px' }}>
                                                Título do Anúncio
                                            </span>
                                            <strong style={{ color: '#f8fafc', fontSize: '1rem' }}>{adDetalhes.titulo}</strong>
                                            {adDetalhes.destaque && <span style={{ marginLeft: '6px', fontSize: '0.85rem' }} title="Anúncio Destacado">⭐ Destacado</span>}
                                        </div>
                                        
                                        <div style={{ background: 'rgba(255, 255, 255, 0.02)', padding: '0.75rem 1rem', borderRadius: '8px', border: '1px solid rgba(255, 255, 255, 0.04)' }}>
                                            <span style={{ fontSize: '0.7rem', color: '#64748b', textTransform: 'uppercase', fontWeight: 700, letterSpacing: '0.5px', display: 'block', marginBottom: '4px' }}>
                                                Preço
                                            </span>
                                            <strong style={{ color: 'var(--color-primary-light)', fontSize: '1.25rem', fontWeight: 700 }}>
                                                {formatPrice(adDetalhes.preco)}
                                            </strong>
                                        </div>
                                    </div>

                                    {/* Ficha Técnica */}
                                    <div style={{ background: 'rgba(255, 255, 255, 0.02)', padding: '1rem', borderRadius: '8px', border: '1px solid rgba(255, 255, 255, 0.04)' }}>
                                        <h4 style={{ color: '#f8fafc', fontSize: '0.85rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '0.75rem', borderBottom: '1px solid rgba(255,255,255,0.06)', paddingBottom: '0.35rem' }}>
                                            📊 Ficha Técnica
                                        </h4>
                                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1rem', fontSize: '0.8rem' }}>
                                            <div>
                                                <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Categoria:</span>
                                                <strong style={{ color: '#f8fafc' }}>{adDetalhes.categoria || '—'}</strong>
                                            </div>
                                            <div>
                                                <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Raça:</span>
                                                <strong style={{ color: '#f8fafc' }}>{adDetalhes.raca || '—'}</strong>
                                            </div>
                                            <div>
                                                <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Quantidade:</span>
                                                <strong style={{ color: '#f8fafc' }}>{adDetalhes.quantidade || '1'} unidades</strong>
                                            </div>
                                            <div>
                                                <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Peso Médio:</span>
                                                <strong style={{ color: '#f8fafc' }}>
                                                    {adDetalhes.peso_medio ? `${adDetalhes.peso_medio} ${adDetalhes.unidade_peso || 'kg'}` : '—'}
                                                </strong>
                                            </div>
                                            <div>
                                                <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Idade:</span>
                                                <strong style={{ color: '#f8fafc' }}>
                                                    {adDetalhes.idade_meses ? `${adDetalhes.idade_meses} ${adDetalhes.unidade_idade || 'meses'}` : '—'}
                                                </strong>
                                            </div>
                                            <div>
                                                <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Cidade/Estado:</span>
                                                <strong style={{ color: '#f8fafc' }}>
                                                    {adDetalhes.cidade && adDetalhes.estado ? `${adDetalhes.cidade} - ${adDetalhes.estado}` : '—'}
                                                </strong>
                                            </div>
                                            <div>
                                                <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Selo de Inspeção:</span>
                                                <strong style={{ color: '#cbd5e1' }}>{adDetalhes.selo || 'Não possui'}</strong>
                                            </div>
                                            <div>
                                                <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Visualizações:</span>
                                                <strong style={{ color: '#60a5fa' }}>👁️ {adDetalhes.visualizacoes || 0} views</strong>
                                            </div>
                                            <div>
                                                <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Status do Anúncio:</span>
                                                {getStatusBadge(adDetalhes)}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Descrição */}
                                    <div style={{ background: 'rgba(30, 41, 59, 0.4)', padding: '1rem', borderRadius: '8px', border: '1px solid rgba(255, 255, 255, 0.06)' }}>
                                        <span style={{ fontSize: '0.7rem', color: '#64748b', textTransform: 'uppercase', fontWeight: 700, letterSpacing: '0.5px', display: 'block', marginBottom: '6px' }}>
                                            Descrição do Produto
                                        </span>
                                        <p style={{ color: '#e2e8f0', margin: 0, fontSize: '0.85rem', lineHeight: '1.5', whiteSpace: 'pre-wrap' }}>
                                            {adDetalhes.descricao || 'Nenhuma descrição cadastrada.'}
                                        </p>
                                    </div>

                                    {/* Perfil do Anunciante */}
                                    <div style={{ background: 'rgba(34, 197, 94, 0.02)', border: '1px solid rgba(34, 197, 94, 0.15)', borderRadius: '8px', padding: '1rem' }}>
                                        <h4 style={{ color: '#4ade80', fontSize: '0.85rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '0.75rem', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            👤 Informações do Anunciante (Vendedor)
                                        </h4>
                                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '0.75rem', fontSize: '0.8rem' }}>
                                            <div>
                                                <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Nome Completo:</span>
                                                <strong style={{ color: '#f8fafc' }}>{adDetalhes.vendedor_nome || '—'}</strong>
                                            </div>
                                            <div>
                                                <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>E-mail:</span>
                                                <strong style={{ color: '#cbd5e1', wordBreak: 'break-all' }}>{adDetalhes.vendedor_email || '—'}</strong>
                                            </div>
                                            <div>
                                                <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>WhatsApp/Contato:</span>
                                                <strong style={{ color: '#f8fafc' }}>{adDetalhes.vendedor_whatsapp || adDetalhes.vendedor_telefone || '—'}</strong>
                                            </div>
                                            <div>
                                                <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Vendas na Plataforma:</span>
                                                <strong style={{ color: '#4ade80' }}>{adDetalhes.vendedor_vendas || 0} vendas realizadas</strong>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Histórico / Prazos */}
                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.75rem', color: '#64748b', padding: '0 0.25rem' }}>
                                        <span>Publicado em: <strong>{formatDate(adDetalhes.criado_em)}</strong></span>
                                        <span>Válido até: <strong>{formatDate(adDetalhes.data_expiracao)}</strong></span>
                                    </div>

                                </div>
                            ) : (
                                <div style={{ textAlign: 'center', padding: '2rem', color: '#64748b' }}>
                                    Nenhum dado encontrado para carregar.
                                </div>
                            )}

                        </div>

                        {/* Modal Footer com Links e Ações Rápidas */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1.25rem', borderTop: '1px solid rgba(255, 255, 255, 0.08)', paddingTop: '1rem' }}>
                            <div>
                                {adDetalhes && (
                                    <a 
                                        href={`https://agroov.com/anuncio/${adDetalhes.id}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="admin-btn admin-btn-primary"
                                        style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', textDecoration: 'none', padding: '0.5rem 1rem', borderRadius: '8px' }}
                                    >
                                        🌐 Abrir no Site
                                    </a>
                                )}
                            </div>
                            <div style={{ display: 'flex', gap: '8px' }}>
                                <button 
                                    className="admin-btn admin-btn-secondary" 
                                    onClick={() => setAdSelecionado(null)}
                                    style={{ padding: '0.5rem 1.25rem', borderRadius: '8px' }}
                                >
                                    Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Injeção de Estilo Autocontido */}
            <style dangerouslySetInnerHTML={{__html: `
                .admin-ad-row:hover {
                    background: rgba(255, 255, 255, 0.05) !important;
                    transform: translateX(4px);
                }
                @keyframes adminModalFadeIn {
                    from { opacity: 0; transform: scale(0.96) translateY(10px); }
                    to { opacity: 1; transform: scale(1) translateY(0); }
                }
            `}} />
        </div>
    )
}

export default AdminAnuncios
